import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon40: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 20" width={width} height={height} {...props}>
      <Path
        d="M8.48801 7.43198e-06C8.68301 -0.000992568 8.84401 0.0990085 8.93201 0.248009L13.804 5.11901C13.924 5.21101 14.001 5.35501 14 5.51801C14 5.54701 13.997 5.575 13.993 5.603L14 7.49801C14.001 7.77401 13.778 7.99901 13.502 8.00001C13.226 8.00101 13.001 7.77802 13 7.50202L12.993 6.01402L8.521 6.00001C8.277 5.99901 8.07401 5.824 8.03101 5.592L8.02299 5.50201L8.00101 1.00001H1V19H7.5C7.776 19 8 19.224 8 19.5C8 19.776 7.776 20 7.5 20H0.5C0.224 20 0 19.776 0 19.5V0.500007C0 0.224007 0.224 7.43198e-06 0.5 7.43198e-06H8.48801ZM13.5 10C15.985 10 18 12.015 18 14.5C18 16.985 15.985 19 13.5 19C11.015 19 9 16.985 9 14.5C9 12.015 11.015 10 13.5 10ZM16.143 12.205L11.613 17.448C12.158 17.797 12.805 18 13.5 18C15.433 18 17 16.433 17 14.5C17 13.622 16.677 12.82 16.143 12.205ZM13.5 11C11.567 11 10 12.567 10 14.5C10 15.378 10.323 16.18 10.857 16.795L15.387 11.552C14.842 11.203 14.195 11 13.5 11ZM9.005 1.736L9.021 5.00201L12.281 5.012L9.005 1.736Z"
        fill="#A84A76"
      />
    </Icon>
  )
}
